import React from 'react';
import 'twin.macro';
import { MobileSubHeader } from '@teetsh/app/src/components/MobileSubheader';
import { FolderNode } from 'types/sequences';
import { useNavigate } from 'react-router-dom';

interface Props {
  folder?: FolderNode;
  ancestors?: FolderNode[];
  children: any;
}

export function SequenceMobileSubHeader(props: Props) {
  const { folder, ancestors = [] } = props;
  const navigate = useNavigate();
  return (
    <div tw="block md:hidden">
      <MobileSubHeader
        disableBackButton
        onBack={() => {
          if (folder?.type === 'fdp') {
            navigate(`/sequences/${ancestors[ancestors.length - 1].id}`);
            return;
          }
          if (ancestors.length > 0) {
            navigate(
              `/sequences/folders/${ancestors[ancestors.length - 1].id}`,
            );
          } else {
            navigate('/sequences');
          }
        }}
      >
        {props.children}
      </MobileSubHeader>
    </div>
  );
}
